import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { pauseClass } from "../../../services/classes.service";
import { toast } from "react-toastify";
import './style.scss';
const AutoTurnOnModal = ({ show, handleClose, id, classType, isPaused, classDetails }:any) => {
  const [selectedOption, setSelectedOption] = useState(classType ? classType:'none');
  const [selectedDate, setSelectedDate] = useState('');
  const handleChange = async(event:any) => {
    setSelectedOption(event.target.value);
  };

  const handleDateChange = async(event: any) => {
    setSelectedDate(event.target.value)
  }

  const handleSubmit =  async(event:any) => {
    event.preventDefault();
    if(["oneDay", "specificDate", "tillTurnOn"].includes(selectedOption)){
      let obj:any = {
        type: "none",
      }
      if(selectedOption == "specificDate" && selectedDate != ""){
        obj.type = selectedOption;
        obj.date = selectedDate
      }
      else{
        obj.type = selectedOption;
      }
      const result = await pauseClass(id, { classPause: obj})
      if (result.data) {
        toast.success("Classes Updated successfully");
        handleClose()
      }
    }
    else{
      toast.error("Please select a valid option");
    }
  }

  useEffect(()=>{
    if(classDetails && classDetails?.classPause?.type && ["oneDay", "specificDate", "tillTurnOn"].includes(classDetails?.classPause?.type)){
      setSelectedOption(classDetails.classPause.type)
      if(classDetails.classPause.type == "specificDate"){  
        setSelectedDate(classDetails.classPause.date)
      }
    }
  }, [])

  return (
    <Modal show={show} onHide={handleClose} centered className="autoTurnModal">
      <Modal.Header closeButton>
        <Modal.Title>Pause the class for...</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Check
            type="radio"
            label="1 day"
            name="oneDay"
            value="oneDay"
            checked={selectedOption === "oneDay"}
            onChange={handleChange}
            className="mb-3"
          />
          <Form.Check
            type="radio"
            label={
              <>
                Pause for specific date{" "}
                <Form.Control
                type="date"
                className="date-picker-input"
                onChange={handleDateChange}
              />
              {/* <FaCalendarAlt className="calendar-icon" /> */}
              </>
            }
            name="auto-turn-on"
            value="specificDate"
            checked={selectedOption === "specificDate"}
            onChange={handleChange}
            className="mb-3"
          />
          <Form.Check
            type="radio"
            label="Until I make it active"
            name="tillTurnOn"
            value="tillTurnOn"
            checked={selectedOption === "tillTurnOn"}
            onChange={handleChange}
            className="mb-3"
          />
          <Button variant="dark" type="submit" className="w-100 mt-3">
            Save
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AutoTurnOnModal;
